var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 37.4C28.8 37.6 29.2 37.6 29.5 37.4L37 33.3C37.3 33.1 37.5 32.8 37.5 32.4C37.5 32 37.3 31.7 37 31.5L29.5 27.6C29.2 27.4 28.8 27.5 28.5 27.6C28.2 27.8 28 28.1 28 28.5V36.5C28 36.9 28.2 37.2 28.5 37.4ZM34.4 32.4L30 34.8V30.1L34.4 32.4Z",
    fill: "#1790FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23H2C0.9 23 0 23.9 0 25V40C0 41.1 0.9 42 2 42H17C18.1 42 19 41.1 19 40V25C19 23.9 18.1 23 17 23ZM17 25V35.1L14.1 31.5L10.1 35.5L4.9 29.2L2.1 34.2V25H17ZM2 40V38.3L5.2 32.8L10 38.5L14 34.5L17.1 38.4V40H2Z",
    fill: "#1790FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 31C12.1046 31 13 30.1046 13 29C13 27.8954 12.1046 27 11 27C9.89543 27 9 27.8954 9 29C9 30.1046 9.89543 31 11 31Z",
    fill: "#1790FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 23H25C23.9 23 23 23.9 23 25V40C23 41.1 23.9 42 25 42H40C41.1 42 42 41.1 42 40V25C42 23.9 41.1 23 40 23ZM40 40H25V25H40V40Z",
    fill: "#1790FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H25C23.9 0 23 0.9 23 2V17C23 18.1 23.9 19 25 19H40C41.1 19 42 18.1 42 17V2C42 0.9 41.1 0 40 0ZM40 17H25V2H40V17Z",
    fill: "#1790FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H31V14C31 14.8 31.7 15.5 32.5 15.5C33.3 15.5 34 14.8 34 14V6H37C37.6 6 38 5.6 38 5C38 4.4 37.6 4 37 4H28C27.4 4 27 4.4 27 5C27 5.6 27.4 6 28 6Z",
    fill: "#1790FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V0H2H0V2V4H2V2Z",
    fill: "#1790FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0V2H17V4H19V2V0H17H15Z",
    fill: "#1790FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H15V19H17H19V17V15H17V17Z",
    fill: "#1790FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19V17H2V15H0V17V19H2H4Z",
    fill: "#1790FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H17V11H19V8Z",
    fill: "#1790FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H0V11H2V8Z",
    fill: "#1790FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17H8V19H11V17Z",
    fill: "#1790FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H8V2H11V0Z",
    fill: "#1790FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilder);
export default __webpack_public_path__ + "static/media/builder.0e3d664c.svg";
export { ForwardRef as ReactComponent };